import {BehaviorSubject, combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {currencies$, spots$} from './config';

export const coinOptions$ = new BehaviorSubject([]);

combineLatest([currencies$, spots$])
  .pipe(map(([currencies, spots]) => convertCoinOptions(currencies, spots)))
  .subscribe((x) => coinOptions$.next(x));

function convertCoinOptions(currencies, spots) {
  return currencies
    .filter((item) => !!item.inAssetsDisplay)
    .map((item) => ({
      text: item.currency,
      value: item.currency,
      name: item.name,
    }));
}
